import { Button } from "baseui/button";
import { ButtonGroup, MODE } from "baseui/button-group";
import { BsGrid1X2, BsPinMapFill } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";

export const RootPageSelector = () => {
    const nav = useNavigate();
    const location = useLocation();
    
    return(
        <div style={{ float: 'right' }}>
                <ButtonGroup size="compact" kind="tertiary"
                    mode={MODE.radio}>
                    <Button onClick={() => nav('/objects')} isSelected={location.pathname === '/objects'}><BsGrid1X2 /></Button>
                    <Button  onClick={() => nav('/buildingsmap')} isSelected={location.pathname === '/buildingsmap'}><BsPinMapFill /></Button>
                    <Button onClick={() => nav('/buildinginsights')} isSelected={location.pathname === '/buildinginsights'}>💡</Button>
                </ButtonGroup>
            </div>
    )
}